import projectConfig from 'project.config'

export function getImagePath(path) {
  return `${projectConfig.publicPath}images/${path}`
}

export function getAudioPath(path) {
  return `${projectConfig.publicPath}mp3/${path}`
}

export function getJSONPath(path) {
  return `${projectConfig.publicPath}json/${path}`
}

const jsonCache = new Map()

export async function loadJSON(path) {
  const url = getJSONPath(path)

  if (jsonCache.has(url)) {
    return jsonCache.get(url)
  }

  const promise = fetch(url).then((res) => {
    if (!res.ok) {
      throw new Error(`Failed to load JSON: ${url}`)
    }

    return res.json()
  })

  jsonCache.set(url, promise)

  return promise.catch((error) => {
    jsonCache.delete(url)
    throw error
  })
}
